/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignHereTab
 */
export interface SignHereTab {
    /**
     * The X-coordinate of the signature on the page, in pixels
     * @type {number}
     * @memberof SignHereTab
     */
    xPosition: number;
    /**
     * The Y-coordinate of the signature on the page, in pixels
     * @type {number}
     * @memberof SignHereTab
     */
    yPosition: number;
    /**
     * Specifies the scale factor for the signature size. Accepts values between 0.5 and 2. The default value is 1.0 (400×145 pixels)
     * @type {number}
     * @memberof SignHereTab
     */
    scaleValue: number;
    /**
     * The ID of the document where the signature field is placed
     * @type {string}
     * @memberof SignHereTab
     */
    documentId: string;
    /**
     * The page number of the document where the signature field is placed
     * @type {number}
     * @memberof SignHereTab
     */
    pageNumber: number;
}

/**
 * Check if a given object implements the SignHereTab interface.
 */
export function instanceOfSignHereTab(value: object): boolean {
    if (!('xPosition' in value)) return false;
    if (!('yPosition' in value)) return false;
    if (!('scaleValue' in value)) return false;
    if (!('documentId' in value)) return false;
    if (!('pageNumber' in value)) return false;
    return true;
}

export function SignHereTabFromJSON(json: any): SignHereTab {
    return SignHereTabFromJSONTyped(json, false);
}

export function SignHereTabFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignHereTab {
    if (json == null) {
        return json;
    }
    return {
        
        'xPosition': json['xPosition'],
        'yPosition': json['yPosition'],
        'scaleValue': json['scaleValue'],
        'documentId': json['documentId'],
        'pageNumber': json['pageNumber'],
    };
}

export function SignHereTabToJSON(value?: SignHereTab | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'xPosition': value['xPosition'],
        'yPosition': value['yPosition'],
        'scaleValue': value['scaleValue'],
        'documentId': value['documentId'],
        'pageNumber': value['pageNumber'],
    };
}

